<button
  (click)="handleClick.emit($event)"
  [attr.data-gtm]="gtmTag"
  [disabled]="isDisabled"
  [id]="buttonId"
  [ngClass]="[
    isSecondary
      ? 'mat-stroked-button button-secondary'
      : 'mat-flat-button button-primary',
    buttonClassName
  ]"
  class="button"
  mat-button
>
  <div class="button__wrapper">
    <span
      [ngClass]="{ 'is-external-operation': isExternalOperation }"
      class="button__text"
      >{{ buttonText }}<ng-content></ng-content
    ></span>
    <span *ngIf="isExternalOperation" class="button__icon">
      <ui-svg-icon
        iconClassName="icon-button--external"
        svgId="external-link"
      ></ui-svg-icon>
    </span>
  </div>
</button>
